import { Config } from '@config/base';
import { browserTracingIntegration, init, replayIntegration } from '@sentry/angular';

import { environment } from './environments/environment';

//if (environment.production)
export function initSentry() {
  if (environment.production) {
    init({
      environment: environment.production ? 'production' : 'development',
      release: `api@EBOPro-v${Config.version}`, // Set the release version, which is matches the GitHub release version
      dsn: 'https://0a2a18370db94d64abbc518d072ea488@o1371157.ingest.us.sentry.io/6684622',
      integrations: [
        // Registers and configures the Tracing integration,
        // which automatically instruments your application to monitor its
        // performance, including custom Angular routing instrumentation
        browserTracingIntegration(),
        // Registers the Replay integration,
        // which automatically captures Session Replays
        replayIntegration()
      ],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for tracing.
      // We recommend adjusting this value in production
      // Learn more at
      // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
      //tracesSampleRate: 1.0,
      tracesSampleRate: environment.production ? 0.05 : 0.25,

      // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
      tracePropagationTargets: ['localhost', /^https:\/\/ebopro\.app\/api/],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      // Learn more at
      // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
      replaysSessionSampleRate: environment.production ? 0.01 : 0,
      replaysOnErrorSampleRate: environment.production ? 1 : 0
      // replaysSessionSampleRate: 0.1,
      // replaysOnErrorSampleRate: 1.0,
      // {
      //       dsn: 'https://0a2a18370db94d64abbc518d072ea488@o1371157.ingest.sentry.io/6684622',
      //       integrations: [
      //         new BrowserTracing({
      //           //tracingOrigins: [environment.api_url, /^\//],
      //           tracingOrigins: ['localHost', 'ebopro.app', /^\//],
      //           routingInstrumentation: Sentry.routingInstrumentation
      //         })
      //       ],
      // }
    });
    console.log('----> Sentry Enabled <----');
  }
  //if (debugBuild)
}
